export default __webpack_public_path__ + "static/media/yvonne_ho.ad2869d0.jpg";